import { MutationTree } from 'vuex'
import State, { IMaterialConfiguration } from './types'
import { Model } from '../model-viewer/types'
import { blankConfiguration } from './constants'

export const mutations: MutationTree<State> = {
  materialsLoaded(state, materials: Model[]) {
    state.Error = false
    state.materials = materials
    state.materialsCatalogLoaded = true
  },
  materialsError(state) {
    state.Error = true
    state.materials = []
    state.materialsCatalogLoaded = false
  },
  configurationLoaded(state, configuration: IMaterialConfiguration) {
    state.Error = false
    state.configuration = configuration
    state.configurationLoaded++
  },
  clearConfiguration(state) {
    state.configuration = blankConfiguration
  },
  resetRequest(state) {
    state.request.MaterialNumber = ''
    state.request.CustomerNumber = ''
    state.request.UserValues = []
    state.request.Values = []
  },
}
